// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-3735f646] {\n  width: 120px;\n  height: 140px;\n}\n@media (min-width: 640px) {\n.card[data-v-3735f646] {\n    width: 102px;\n    height: 123px;\n}\n}\nimg[data-v-3735f646] {\n  height: 80px;\n}", ""]);
// Exports
module.exports = exports;
